import React, { useState } from 'react'
import { Button } from 'components/ui';
import { TbSquareRoundedPlus } from 'react-icons/tb';
import dayjs from 'dayjs';
import ChatTemplateChatListItem from './ChatTemplateChatListItem';

const chatGroups = [
  {
    label: 'Today',
    from: dayjs().startOf('day'),
    to: dayjs().endOf('day')
  },
  {
    label: 'Previous 7 days',
    from: dayjs().subtract(7, 'days').startOf('day'),
    to: dayjs().endOf('day')
  },
  {
    label: 'Previous 30 days',
    from: dayjs().subtract(30, 'days').startOf('day'),
    to: dayjs().endOf('day')
  },
  {
    label: 'Old',
    from: dayjs().subtract(30000, 'days').startOf('day'),
    to: dayjs().subtract(31, 'days').endOf('day')
  },
]

export default function ChatTemplateChatList({
  chats,
  selectedChatId,
  setSelectedChatId,
  getMessages,
  updateChatTitle
}) {
  
  const [ isEditing, setIsEditing ] = useState(-1);

  chats = chats.map(chat => ({
    ...chat,
    group: chatGroups.find(group => group.from.toDate() <= new Date(chat.created_at) && group.to.toDate() >= new Date(chat.created_at))
  }));

  return (
    <div className='h-full flex flex-col gap-4 border-r border-tertiary-100 dark:border-gray-600 bg-secondary-400 dark:bg-gray-900 p-2.5 overflow-y-auto'>
      <Button
        variant="twoTone"
        className="!px-4 shrink-0"
        onClick={() => setSelectedChatId(undefined)}
      >
        <div className='w-full flex justify-between items-center'>
          <div className='flex items-center gap-2'>
            <span>New chat</span>
          </div>
          <TbSquareRoundedPlus className='text-xl' />
        </div>
      </Button>
      {!!chats?.length && 
        <div className='w-full flex flex-col gap-2 mt-0'>
          {chatGroups?.filter(e => !!chats?.find(c => c?.group?.label == e?.label)).map(group => (
            <div className='w-full flex flex-col'>
              <div className='mb-2 mt-5 px-2.5 font-semibold text-[11px] text-tertiary-400 dark:text-gray-600'>{group.label}</div>
              {chats.filter(c => c.group.label == group.label).map((chat, key) => (
                <ChatTemplateChatListItem 
                  key={chat?.id}
                  chat={chat}
                  isEditing={isEditing}
                  setIsEditing={setIsEditing}
                  selectedChatId={selectedChatId}
                  setSelectedChatId={setSelectedChatId}
                  getMessages={getMessages}
                  updateChatTitle={updateChatTitle}
                />
              ))}
            </div>
          ))}
        </div>
      }
    </div>
  )
}
